/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Widget_Icon_BetaInputs */

const en_enum_widget_icon_beta = /** @type {(inputs: Enum_Widget_Icon_BetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta`)
};

const de_enum_widget_icon_beta = /** @type {(inputs: Enum_Widget_Icon_BetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta`)
};

/**
* | output |
* | --- |
* | "Beta" |
*
* @param {Enum_Widget_Icon_BetaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_widget_icon_beta = /** @type {((inputs?: Enum_Widget_Icon_BetaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Widget_Icon_BetaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_widget_icon_beta(inputs)
	return de_enum_widget_icon_beta(inputs)
});